import { MenuNode } from '../sidebar/menu-tree';
import { PaletteCommand } from './command-palette.model';

/** One command per page of the menu the user can see (the tree is already filtered by permissions). */
export function pageCommands(nodes: readonly MenuNode[], currentKey: string | undefined, navigate: (routerLink: any[]) => void): PaletteCommand[] {
  const commands: PaletteCommand[] = [];
  const visit = (node: MenuNode, ancestors: MenuNode[]) => {
    const routerLink = node.routerLink;
    if (routerLink) {
      commands.push({
        id: `page:${node.key}`,
        group: 'pages',
        title: node.label,
        hint: ancestors.map((ancestor) => ancestor.label),
        icon: node.icon ?? ancestors[0]?.icon,
        current: node.key === currentKey,
        run: () => navigate(routerLink),
      });
    }
    node.children.forEach((child) => visit(child, [...ancestors, node]));
  };
  nodes.forEach((node) => visit(node, []));
  return commands;
}

export interface SidebarCommandContext {
  /** False on small screens (drawer) and for users without a sidebar. */
  canCollapse: boolean;
  collapsed: boolean;
  hasMenu: boolean;
  /** Shown next to the collapse/expand command, e.g. "Ctrl B". */
  toggleShortcut?: string;
  /** Shown next to expand all / collapse all, e.g. "Ctrl I" (one shortcut toggles both). */
  expandCollapseShortcut?: string;
  toggleCollapsed(): void;
  expandAll(): void;
  collapseAll(): void;
}

export function sidebarCommands(context: SidebarCommandContext): PaletteCommand[] {
  const commands: PaletteCommand[] = [];
  if (context.canCollapse) {
    commands.push({
      id: 'sidebar:toggle',
      group: 'actions',
      title: context.collapsed ? 'commandPalette.commands.expandSidebar' : 'commandPalette.commands.collapseSidebar',
      icon: context.collapsed ? 'pi pi-angle-double-right' : 'pi pi-angle-double-left',
      keywords: ['sidebar', 'menu', 'rail'],
      shortcut: context.toggleShortcut,
      run: () => context.toggleCollapsed(),
    });
  }
  if (context.hasMenu) {
    commands.push(
      {
        id: 'sidebar:expand-all',
        group: 'actions',
        title: 'layout.sidebar.expandAll',
        icon: 'pi pi-angle-double-down',
        keywords: ['sidebar', 'menu', 'sections'],
        shortcut: context.expandCollapseShortcut,
        run: () => context.expandAll(),
      },
      {
        id: 'sidebar:collapse-all',
        group: 'actions',
        title: 'layout.sidebar.collapseAll',
        icon: 'pi pi-angle-double-up',
        keywords: ['sidebar', 'menu', 'sections'],
        shortcut: context.expandCollapseShortcut,
        run: () => context.collapseAll(),
      },
    );
  }
  return commands;
}
